export { default } from "./PortraitVideoCard";
